var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.803,
    height: 19.379,
    viewBox: "0 0 15.803 19.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161708",
    "data-name": "Group 161708",
    transform: "translate(0.75 -6.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file",
    transform: "translate(0 6.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_723",
    "data-name": "Path 723",
    d: "M12.045,2H5.788A1.788,1.788,0,0,0,4,3.788v14.3a1.788,1.788,0,0,0,1.788,1.788H16.515A1.788,1.788,0,0,0,18.3,18.091V8.258Z",
    transform: "translate(-4 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_724",
    "data-name": "Path 724",
    d: "M13,2V8.258h6.258",
    transform: "translate(-4.955 -2)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsBlackIcon);
export default __webpack_public_path__ + "static/media/docs-black-icon.154ff051548b0eb1f5032ffa8c045ab6.svg";
export { ForwardRef as ReactComponent };